/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleRentalSummary
 */
export interface VehicleRentalSummary {
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalSummary
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalSummary
     */
    vendorCode?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalSummary
     */
    vehicleDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalSummary
     */
    vehicleClass?: string;
}

/**
 * Check if a given object implements the VehicleRentalSummary interface.
 */
export function instanceOfVehicleRentalSummary(value: object): value is VehicleRentalSummary {
    return true;
}

export function VehicleRentalSummaryFromJSON(json: any): VehicleRentalSummary {
    return VehicleRentalSummaryFromJSONTyped(json, false);
}

export function VehicleRentalSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleRentalSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'vendorName': json['vendor_name'] == null ? undefined : json['vendor_name'],
        'vendorCode': json['vendor_code'] == null ? undefined : json['vendor_code'],
        'vehicleDescription': json['vehicle_description'] == null ? undefined : json['vehicle_description'],
        'vehicleClass': json['vehicle_class'] == null ? undefined : json['vehicle_class'],
    };
}

export function VehicleRentalSummaryToJSON(json: any): VehicleRentalSummary {
    return VehicleRentalSummaryToJSONTyped(json, false);
}

export function VehicleRentalSummaryToJSONTyped(value?: VehicleRentalSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vendor_name': value['vendorName'],
        'vendor_code': value['vendorCode'],
        'vehicle_description': value['vehicleDescription'],
        'vehicle_class': value['vehicleClass'],
    };
}

